/* eslint-disable no-dupe-keys */
export default {
  evcs_notification_order: {
    name: '政府平台推送订单',
    // 属性（一般与对象内容匹配）
    prop: {
      start_charge_seq: '充电订单号',
      evcs_operator: '平台商',
      order: '订单',
      notification_status: '推送状态',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      start_charge_seq: '充电订单号',
      evcs_operator_id: '平台商',
      order_id: '订单',
      order_start_time: '充电开始时间',
      order_finish_time: '充电结束时间',
      notification_status: '推送状态',
      charge_station: '充电站'
    },
    // Enum的属性
    notification_statuses: {
      pending: '待推送',
      notify_fail: '失败',
      notify_success: '成功'
    },
    summary: {
      latest_7_days_should_push_orders_count: '近七天应推送订单数',
      latest_7_days_total_count: '近七天实推送订单数',
      latest_7_days_total_fail_count: '近七天推送订单失败数'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询充电订单号'
    }
    // 详情页标签
  }
}
